import { Card } from "@/components/ui/card";

interface ReceiveIssueSettingsStateProps {
  isLoading: boolean;
  className?: string;
}

export function ReceiveIssueSettingsState({
  isLoading,
  className,
}: ReceiveIssueSettingsStateProps) {
  return (
    <Card className={className}>
      <p
        role={isLoading ? "status" : "alert"}
        className={isLoading ? "p-6 text-sm text-muted-foreground" : "p-6 text-sm text-destructive"}
      >
        {isLoading
          ? "Loading catalog settings…"
          : "Could not load catalog settings. Receiving is unavailable."}
      </p>
    </Card>
  );
}
